import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Nevbars/Navbar';
import Home from './Pagess/Home/Home';
import Aboutus from './Pagess/About Sections/Aboutus';
import Footer from './Components/Footer/Footer';
import Service from './Pagess/Services/Service';
import Service_detals from './Pagess/Services/Service_Detials/Service_detals';
import Contact from './Pagess/Contact us/Contact';
function App() {
  return (
    <>
      <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:slug" element={<Service />} />
          <Route path="/service-detail/:id" element={<Service_detals />} />
          <Route path="/Aboutus" element={<Aboutus />} />
          <Route path="/Contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </>
  )
}

export default App